import { ERROR_LOG_MAX_BLOB_BYTES } from 'data/error-log-constants';
import { getErrorLogJsonByteLength } from 'utils/error-log/get-error-log-json-byte-length';

export function isErrorLogJsonBlobWithinLimit(value: unknown): boolean {
  if (value === undefined || value === null) {
    return true;
  }
  try {
    return getErrorLogJsonByteLength(value) <= ERROR_LOG_MAX_BLOB_BYTES;
  } catch {
    return false;
  }
}
